import React from 'react';
import { formatDistance } from '@unmapped/core/filters/DistanceFilter';
import styles from './styles.module.css';
export const ResultItem = ({
  result,
  onClick
}) => {
  let displayName = result.locationName;
  if (result.fields.search) {
    displayName = result.fields.search.match.map((p, i) => i % 2 !== 0 ? /*#__PURE__*/React.createElement("span", {
      className: styles.match,
      key: i
    }, p) : p);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ResultItem,
    onClick: onClick
  }, result.data.imageUrl && /*#__PURE__*/React.createElement("img", {
    src: result.data.imageUrl,
    className: styles.thumbnail
  }), /*#__PURE__*/React.createElement("h3", {
    className: styles.name
  }, displayName), /*#__PURE__*/React.createElement("div", {
    className: styles.details
  }, result.fields.displayAddress[0], " ", /*#__PURE__*/React.createElement("br", null), result.fields.displayAddress[1]), result.fields.distance && /*#__PURE__*/React.createElement("div", {
    className: styles.distance
  }, formatDistance(result.fields.distance)));
};
export default ResultItem;